export default "/_next/static/chunks/fonts/Roboto-Light-latin-6462f07ab958c7ef883ca0bf37b9a003.woff2";